// extracted by mini-css-extract-plugin
export default {"limits":"LimitsMessage_limits__SyZFx","left":"LimitsMessage_left__rxbx7","right":"LimitsMessage_right__rIgnE","link":"LimitsMessage_link__lmlil"};